import { lazy, Suspense, useEffect } from 'react';
import useDarkMode from '@/utils/hooks/useDarkMode';
import copyToClipboard from '@/utils/copyToClipboard';

const SonnerToaster = lazy(() => import('sonner').then(m => ({ default: m.Toaster })));

const Toaster = () => {
	const [isDark] = useDarkMode();

	useEffect(() => {
		const onContextMenu = (event) => {
			const toast = event.target.closest?.('[data-sonner-toast]');

			if (!toast) {
				return;
			}

			event.preventDefault();

			const text = (toast.querySelector('[data-description]') ?? toast.querySelector('[data-title]'))?.textContent?.trim();

			copyToClipboard(text, undefined, true, 'top-right');
		};

		document.addEventListener('contextmenu', onContextMenu);

		return () => document.removeEventListener('contextmenu', onContextMenu);
	}, []);

	return (<Suspense fallback={null}>
		<SonnerToaster
			theme={isDark ? 'dark' : 'light'}
			position="bottom-center"
			gap={8}
			visibleToasts={5}
			toastOptions={{
				classNames: {
					toast: '!select-none !rounded-xl !bg-neutral-400/25 dark:!bg-black/25 !backdrop-blur-lg !backdrop-saturate-150 !border !border-neutral-500/30 dark:!border-white/10 !shadow-[0_8px_32px_rgba(0,0,0,0.15),inset_0_1px_0_rgba(255,255,255,0.6)] dark:!shadow-[0_8px_32px_rgba(0,0,0,0.5),inset_0_1px_0_rgba(255,255,255,0.1)] !text-neutral-900 dark:!text-neutral-100',
					title: '!text-neutral-900 dark:!text-neutral-100 !font-semibold',
					description: '!text-neutral-700 dark:!text-neutral-300',
					actionButton: '!bg-white/50 dark:!bg-white/10 !border !border-white/80 dark:!border-white/25 !text-neutral-900 dark:!text-neutral-100 hover:!bg-white/70 dark:hover:!bg-white/20',
					cancelButton: '!bg-white/30 dark:!bg-white/5 !border !border-white/60 dark:!border-white/15 !text-neutral-700 dark:!text-neutral-300',
					closeButton: '!bg-neutral-400/25 dark:!bg-black/25 !backdrop-blur-lg !border-neutral-500/30 dark:!border-white/10 !text-neutral-700 dark:!text-neutral-200',
				},
			}}
		/>
	</Suspense>);
};

export default Toaster;
